export const common_globalfooter_copyright_data = Object.freeze({
  24: 'EVENTBIS BRASIL – TECNOLOGIA PARA EVENTOS E TICKETS LTDA, CNPJ 13.827.475/0001-06, Endereço físico: Office 10-107 We Work center - Av. Paulista, 2537 - Bela Vista São Paulo, SP 01311-300 - customer_service_brasil@stubhub.com',
});

export const UK = 2;

export const SAUDI_ARABIA_PDF_LINK =
  'https://media.stubcloudstatic.com/stubhub-ithaca-product/image/upload/v1713273848/legal/SA_VAT/pqqu05zsht1iwhrzrung.pdf';
